var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{ref:"field",attrs:{"label":_vm.$t('clients.form.currency'),"name":"currency","rules":[_vm.required],"disabled":_vm.disabled},model:{value:(_vm.currency),callback:function ($$v) {_vm.currency=$$v},expression:"currency"}})
}
var staticRenderFns = []

export { render, staticRenderFns }